import { ThemeConfig } from 'antd';

import { ThemeColorPresets } from '#/enum';
/**
 * Antd theme editor: https://ant.design/theme-editor-cn
 */
const customThemeTokenConfig: ThemeConfig['token'] = {
  colorSuccess: '#22c55e',
  /** 与 thesis-shell --tt-status-warn-fg 对齐，避免亮橙撞暖纸面 */
  colorWarning: '#d48806',
  colorError: '#ff5630',
  colorInfo: '#2f4a6a',

  // 线性化
  wireframe: false,

  borderRadiusSM: 2,
  borderRadius: 4,
  borderRadiusLG: 8,
};

const customComponentConfig: ThemeConfig['components'] = {
  Breadcrumb: {
    fontSize: 12,
    separatorMargin: 4,
  },
  Menu: {
    fontSize: 14,
    colorFillAlter: 'transparent',
    motionDurationMid: '0.125s',
    motionDurationSlow: '0.125s',
  },
};

const colorPrimarys: {
  [k in ThemeColorPresets]: string;
} = {
  // 论文台主色：墨蓝，浅/深都跟壳一致
  default: '#2f4a6a',
  cyan: '#078DEE',
  purple: '#7635DC',
  blue: '#2065D1',
  orange: '#FDA92D',
  red: '#FF3030',
};

/* 与 thesis-shell 暖色纸面 / 墨色对齐，避免壳暖暗、组件冷灰 */
const themeModeToken: Record<'dark' | 'light', ThemeConfig> = {
  dark: {
    token: {
      colorBgLayout: '#121110',
      colorBgContainer: '#1e1c1a',
      colorBgElevated: '#242220',
      colorBorder: 'rgba(240, 235, 228, 0.12)',
      colorBorderSecondary: 'rgba(240, 235, 228, 0.08)',
      colorText: '#f0ebe4',
      colorTextSecondary: '#a39e96',
      colorTextTertiary: '#8a847c',
    },
    components: {
      Layout: {
        siderBg: '#121110',
        bodyBg: '#121110',
        headerBg: '#121110',
      },
      Menu: {
        darkItemBg: '#121110',
        itemColor: '#a39e96',
        itemSelectedColor: '#f0ebe4',
      },
      Modal: {
        headerBg: '#1e1c1a',
        contentBg: '#1e1c1a',
        footerBg: '#1e1c1a',
      },
      Dropdown: {
        colorBgElevated: '#1e1c1a',
      },
      Notification: {},
    },
  },
  light: {
    token: {
      colorBgLayout: '#f2f0eb',
      colorBgContainer: '#ffffff',
      colorBgElevated: '#ffffff',
      colorText: '#1a1816',
      colorTextSecondary: '#5c5854',
    },
    components: {
      Layout: {
        siderBg: '#f2f0eb',
        bodyBg: '#f2f0eb',
      },
      Menu: {
        itemColor: '#5c5854',
      },
    },
  },
};

export { customThemeTokenConfig, customComponentConfig, colorPrimarys, themeModeToken };
